<div *ngIf="toastService.showToast$ | async"
    [@toastTrigger]="(toastService.showToast$ | async) ? 'open' : 'close' "
    [class]=" toastService.toastState$ | async " [class.top-toast]="device === 'desktop'">

    <img *ngIf=" (toastService.toastState$ | async) == 'success-toast'" src="assets/icons/checkCircleSuccess.svg" />
    <img *ngIf=" (toastService.toastState$ | async) == 'warning-toast'" src="assets/icons/alertCircleWarning.svg" />
    <img *ngIf=" (toastService.toastState$ | async) == 'danger-toast'" src="assets/icons/alertCircleError.svg" />

    <div class="toast-message">
        <div class="toast-header">
            <div class="title"> {{ toastService.toastTitle$ | async }} </div>
            <button class="toast-btn-close" (click)="dismiss()">
                <img src="assets/icons/closeOutlined.svg" />
            </button>
        </div>
        
        <div class="description"> {{ toastService.toastMessage$ | async }} </div>
    </div>
</div>